import React from 'react';

import AskTheAIContainer from './AskTheAIContainer';
import { AskTheAIDetail } from './AskTheAIDetail';

const AskTheAIPage: React.FC = () => (
    <AskTheAIContainer.Provider>
        <AskTheAIDetail/>
    </AskTheAIContainer.Provider>
);
export default AskTheAIPage;
